import { render } from "./EditLiquidation4.vue?vue&type=template&id=903b9fd6"
import script from "./EditLiquidation4.vue?vue&type=script&lang=js"
export * from "./EditLiquidation4.vue?vue&type=script&lang=js"

import "./EditLiquidation4.vue?vue&type=style&index=0&id=903b9fd6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__